<template>
  <div class="product_box cart_product_box flex-r-c-c">
    <div class="pro_info flex-r-s-c">
      <van-image width="2.56rem" height="1.92rem" :src="myinfo.iconUrl" />
      <div class="cart_pro_info">
        <div class="pro_name van-multi-ellipsis--l2">{{ myinfo.name }}</div>
        <div class="pro_brand_model van-ellipsis">{{ myinfo.brand }} | {{ myinfo.specifications }}</div>
        <!-- <div class="pro_tags">1</div> -->
        <div class="pro_bottom flex-r-sb-c">
          <div class="pro_money">￥<span
            style="font-size: 0.49rem;"
          >{{ myinfo.showPrice === 0? myinfo.price :'详询客服' }}</span></div>
          <div class="pro_num_change_no" style="font-size: 0.39rem;">x {{ myinfo.priceNum || myinfo.buyNumber }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: { type: Object, default: () => { } }
  },
  data() {
    return {
      myinfo: this.info
    }
  },
  methods: {

  }
}
</script>
